import React, {Component} from 'react';
import styled from 'styled-components';
import {bindActionCreators} from "redux";
import connect from "react-redux/es/connect/connect";
import {toJS} from "../../to-js";
import * as Actions from "../../actions/actions";
import Counter from "../common/Counter";
import numeral from "numeral";
import Tag from "./Tag";
import Input from "../common/Input";
import InputBlock from "../common/InputBlock";
import CheckBox from "../common/CheckBox";
import CartColumn from "./CartColumn";
import CartRow from "./CartRow";


class CartPage extends Component {

    handleChange = (key, value) => {
        this.props.cartChangeDeliveryInfo({key: key, value: value})
    };

    render() {
        const info = this.props.deliveryInfo;
        return (
            <React.Fragment>
                <CartRow>
                    <div className="col-md-4">
                        <CartColumn title={'Контактные данные'}>
                            <InputBlock>
                                <Input value={info.name}
                                       placeholder="Имя, Фамилия"
                                       type="text"
                                       name="name"
                                       onChange={(e) => this.handleChange('name', e.target.value)}/>
                            </InputBlock>
                            <InputBlock>
                                <Input value={info.phone}
                                       placeholder="Номер телефона"
                                       type="phone"
                                       name="phone"
                                       onChange={(e) => this.handleChange('phone', e.target.value)}/>
                            </InputBlock>
                            <InputBlock>
                                <Input value={info.email}
                                       placeholder="Эл. почта"
                                       type="email"
                                       name="email"
                                       onChange={(e) => this.handleChange('email', e.target.value)}/>
                            </InputBlock>
                            <InputBlock>
                                <CheckBox callback={(value) => this.handleChange('agreed', value)}
                                          checked={info.agreed}
                                          label="Я соглашаюсь с правилами пользования LoguNoliktava.lv. О правилах можно прочесть тут."/>
                            </InputBlock>
                        </CartColumn>
                    </div>
                    {/*<div className={info.delivery === 'self' ? 'col-md-8' : 'col-md-3'}>*/}
                    <div className='col-md-3'>
                        <CartColumn title={'Способ доставки'}>
                            <InputBlock>
                                <CheckBox callback={(value) => this.handleChange('delivery', value)}
                                          checked={info.delivery === 'self'}
                                          type="radio"
                                          name="delivery"
                                          value={'self'}
                                          label="Забрать со склада"/>
                            </InputBlock>
                            <InputBlock>
                                <CheckBox callback={(value) => this.handleChange('delivery', value)}
                                          checked={info.delivery === 'courier'}
                                          type="radio"
                                          name="delivery"
                                          value={'courier'}
                                          label="Доставка нашим курьером"/>
                            </InputBlock>
                        </CartColumn>
                    </div>
                    <div className="col-md-5">
                        {info.delivery !== 'self' ?
                            <CartColumn title={'Адрес доставки'}>
                                <InputBlock>
                                    <Input value={info.address}
                                           placeholder="Адрес"
                                           type="text"
                                           name="address"
                                           onChange={(e) => this.handleChange('address', e.target.value)}/>
                                </InputBlock>
                                <InputBlock>
                                    <Input value={info.city}
                                           placeholder="Город"
                                           type="text"
                                           name="city"
                                           onChange={(e) => this.handleChange('city', e.target.value)}/>
                                </InputBlock>
                                <InputBlock>
                                    <Input value={info.postcode}
                                           placeholder="Почтовый индекс"
                                           type="text"
                                           name="postcode"
                                           onChange={(e) => this.handleChange('postcode', e.target.value)}/>
                                </InputBlock>
                            </CartColumn> : ''}
                        {info.delivery === 'self' ?
                            <CartColumn title='&nbsp;'>
                                <p>
                                    Наш склад работает с 6:00 до 17:00 по рабочим дням, не считая первой субботы месяца,
                                    дня лунного затмения и последнего воскресенья каждого квартала
                                </p>
                            </CartColumn> : ''}
                    </div>
                </CartRow>
            </React.Fragment>
        );
    }
}

function mapStateToProps(state) {
    return {
        deliveryInfo: state.getIn(['cart', 'delivery_info'])
    };
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        cartChangeDeliveryInfo: Actions.cartChangeDeliveryInfo,
    }, dispatch)
}

export default connect(mapStateToProps, mapDispatchToProps)(toJS(CartPage));